import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { Slide } from "react-awesome-reveal";
import {
    MiddleBlockSection,
    ContentTitle,
    ContentWrapper,
    ContentQuestion,
    ContentText,
    SemicircleRectangle1,
    SemicircleRectangle2,
    RightColumnContent,
    BottomRightAligned,
    StyledImage,
    OverlayWrapper
} from "./styles";

interface MiddleBlockProps {
    question: string;
    title: string;
    text: string;
    text2: string;
    id: string;
    direction: string;
    button: string;
    t: TFunction;
}

const MiddleBlock = ({
    question,
    title,
    text,
    text2,
    id,
    direction,
    button,
    t
}: MiddleBlockProps) => {
    return (
        <MiddleBlockSection id={id}>
            <Row justify="center" align="middle">
                <ContentWrapper>
                    <Col lg={12} md={12} sm={24} xs={24} className="left-column">
                        <OverlayWrapper>
                            <SemicircleRectangle1 />
                            <StyledImage src="/img/physician.jpg" alt="Physician" />
                        </OverlayWrapper>
                    </Col>

                    <Col lg={12} md={12} sm={24} xs={24} className="right-column">
                        <RightColumnContent>
                            <Slide direction="right" triggerOnce>
                                <ContentQuestion>{t(question)}</ContentQuestion>
                                <ContentTitle>{t(title)}</ContentTitle>
                                <ContentText>
                                    {t(text)
                                        .split("PremierOne Plus IDS (POPIDS)")
                                        .map((part, index, arr) =>
                                            index < arr.length - 1 ? (
                                                <span key={index}>
                                                    {part}
                                                    <strong style={{ color: "#2A3273" }}>
                                                        PremierOne Plus IDS (POPIDS)
                                                    </strong>
                                                </span>
                                            ) : (
                                                part
                                            )
                                        )}
                                </ContentText>
                                <ContentText>
                                    {t(text2).split(/(restricted Knox-Keene licensed health plan|dual risk \(full risk\))/g).map((part, index) =>
                                        part === "restricted Knox-Keene licensed health plan" || part === "dual risk (full risk)" ? (
                                            <strong key={index}>{part}</strong>
                                        ) : (
                                            part
                                        )
                                    )}
                                </ContentText>
                            </Slide>
                            <BottomRightAligned>
                                <SemicircleRectangle2 />
                            </BottomRightAligned>
                        </RightColumnContent>
                    </Col>
                </ContentWrapper>
            </Row>
        </MiddleBlockSection>
    );
};

export default withTranslation()(MiddleBlock);
